import CloseModalIcon from "../../../shared-components/icons/CloseModalIcon";
import { useBotbRAFContext } from "../context";
import { PageState } from "../provider";
import { ReferAFriendOnboarding } from "./ReferAFriendOnboarding";

const RAFModal = () => {
  const { state, setFTU } = useBotbRAFContext();

  return (
    <>
      <div data-name="Overlay" className="fixed-theme inset-0 z-[9999] bg-black/80"></div>
      <div
        data-name="PopupContainer"
        className={"fixed-theme inset-0 z-[99999] w-full min-h-full overflow-x-hidden overflow-y-auto"}>
        <div className={"w-full min-h-full flex-center flex-col"}>
          <div
            className={
              "bg-white max-lg:grow font-jost relative flex flex-col max-lg:size-full min-h-full lg:min-h-[540px] lg:w-[600px] lg:max-w-[600px] lg:rounded-lg"
            }>
            <div className={"w-full h-14 lg:h-8 max-lg:mb-6 relative"}>
              <button onClick={setFTU} className={"absolute top-2 right-2 lg:top-4 lg:right-4"}>
                <CloseModalIcon className={"size-6 text-gray-5"} />
              </button>
            </div>

            {state === PageState.ONBOARDING && (
              <>
                <ReferAFriendOnboarding />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RAFModal;
